import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DesignPresenceDto } from './design-presence.model';

const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api`;

@Injectable({
  providedIn: 'root'
})
export class DesignPresenceApiService {

  constructor(private _http: HttpClient) { }

  getDesignPresence(): Observable<DesignPresenceDto[]> {
    return this._http.get<DesignPresenceDto[]>(`${PeriforApiEndpoint}/wellbores/all/designs/presence`);
  }

}
